import { map, mapValues, groupBy, reduce } from 'lodash';
import { getConfig } from '../utils/support';


export const items = state => state.items;

/**
 * Custom "panel" getter as we do not want to have the configurations
 * reactive. They would spit out vuex mutation errors all over the place.
 *
 * @param state
 */
export const panels = state => map(
  state.items,
  panel => ({ ...panel, config: getConfig(panel.key) }),
);

/**
 * Groups all opened panels by their key and id.
 *
 * @param state
 */
export const active = state => mapValues(
  groupBy(state.items, 'key'),
  item => reduce(item, (result, entry) => {
    result[entry.id] = entry;
    return result;
  }, {}),
);

/**
 * Fetches the active panel with the given key and ID.
 *
 * It is not specified which panel exactly, but as they share their data,
 * it should not matter for displaying their content.
 *
 * @param state
 * @param getters
 */
export const fetch = (state, getters) => (key, id) => {
  const type = getters.active[key];
  return type ? type[id] : null;
};



// WEBPACK FOOTER //
// ./resources/assets/js/view-stack/store/getters.js